import { FC } from 'react';
import { Typography, Box } from '@mui/material';

interface AccountTypeProps {
  accountType: string;
}

const AccountType: FC<AccountTypeProps> = ({ accountType }) => {
  const isSaving = accountType === 'Saving Account';
  const isCurrent = accountType === 'Current Account';
  const isFixed = accountType === 'Fixed Deposit';

  const displayName = isSaving
    ? 'Savings'
    : isCurrent
    ? 'Current'
    : isFixed
    ? 'Fixed'
    : accountType;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--bg-color)',
        borderRadius: '50px',
        padding: '4px 8px',
        textAlign: 'center',
        width: '90px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Outfit',
          fontWeight: 400,
          fontSize: '12px',
          color: isSaving
            ? 'var(--saving-acc-color)'
            : isCurrent
            ? 'var(--current-acc-color)'
            : isFixed
            ? 'var(--fixed-dep-color)'
            : undefined,
          border: '1px solid',
          borderColor: isSaving
            ? 'var(--saving-acc-border)'
            : isCurrent
            ? 'var(--current-acc-border)'
            : isFixed
            ? 'var(--fixed-dep-border)'
            : 'transparent',
          borderRadius: '7px',
          padding: '0 4px',
          height: '24px',
          width: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {displayName}
      </Typography>
    </Box>
  );
};

export default AccountType;
